import { render, staticRenderFns } from "./DemoAutomators.vue?vue&type=template&id=578b7880&scoped=true&"
import script from "./DemoAutomators.vue?vue&type=script&lang=js&"
export * from "./DemoAutomators.vue?vue&type=script&lang=js&"
import style0 from "./DemoAutomators.vue?vue&type=style&index=0&id=578b7880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578b7880",
  null
  
)

export default component.exports